export const decodeOffsetKey = (offsetKey: any) => {
  const [blockKey, decoratorKey, leafKey] = offsetKey.split('-')
  return {
    blockKey,
    decoratorKey: parseInt(decoratorKey, 10),
    leafKey: parseInt(leafKey, 10),
  }
}
